/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type DocumentStatus = typeof DocumentStatus[keyof typeof DocumentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentStatus = {
  DRAFT: 'DRAFT',
  UPLOADED: 'UPLOADED',
  PROCESSING: 'PROCESSING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
} as const;
